<template>
    <div class="network" v-loading="loading" element-loading-text="拼命加载中">
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="日期：">
                    <el-date-picker 
                        style="width:120px;"
                        @change="search"
                        format="YYYY-MM"
                        value-format="YYYYMM"
                        v-model="formInline.month"
                        type="month"
                        placeholder="选择月">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="地区：">
                    <el-select v-model="formInline.region" clearable style="width:120px" @change="search" placeholder="请选择">
                        <el-option
                            v-for="(item,index) in regionList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Payers：" v-if="curRole!='customer'">
                    <el-select v-model="formInline.payer_id" clearable filterable style="width:120px" @change="search" placeholder="请选择">
                        <el-option
                            v-for="(item,index) in payersList"
                            :key="index"
                            :label="item.name+'('+item.payer_id+')'"
                            :value="item.payer_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="销售：" v-if="curRole=='admin'">
                    <el-select clearable filterable v-model.trim="formInline.sales" placeholder="请选择" @change="search" style="width:120px">
                        <el-option
                            v-for="item in salesList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="伙伴：" v-if="curRole=='admin'||curRole=='sales'">
                    <el-select clearable filterable v-model.trim="formInline.agent_id" placeholder="请选择" @change="search" style="width:120px">
                        <el-option
                            v-for="item in agentsList"
                            :key="item.agent_id"
                            :label="item.company"
                            :value="item.agent_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="客户：" v-if="curRole!='customer'">
                    <el-select v-model="formInline.company_id" clearable filterable style="width:120px" @change="search" placeholder="请选择">
                        <el-option
                            v-for="(item,index) in customersList"
                            :key="index"
                            :label="item.company"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-row>
                <el-col :span="6">
                    <el-card class="h120" v-if="networkData && networkData.lastMonthSum && networkData.curMonthSum">
                        <div class="title">总费用</div>
                        <div class="cost">
                            <div class="left">
                                <p>{{ networkData.lastMonthSum.month }}</p>
                                <p class="num">{{formInline.region=='cn'?'¥':'$'}}{{ Number(networkData.lastMonthSum.costSum).toFixed(4) }}</p>
                                <p class="num last">{{formInline.region=='cn'?'¥':'$'}}{{ Number(networkData.lastMonthSum.creditSum).toFixed(4) }}</p>
                            </div>
                            <div class="left">
                                <p>{{ networkData.curMonthSum.month }}</p>
                                <p class="num">{{formInline.region=='cn'?'¥':'$'}}{{ networkData.curMonthSum.costSum }}</p>
                                <p class="num last">{{formInline.region=='cn'?'¥':'$'}}{{ networkData.curMonthSum.creditSum }}</p>
                            </div>
                        </div>
                        <div class="percent">
                            <div style="font-size:24px;" v-if="Number(networkData.lastMonthSum.costSum) != Number(networkData.curMonthSum.costSum)">
                                {{ percentage(networkData.lastMonthSum.costSum,networkData.curMonthSum.costSum) }}
                                <img :src="Number(networkData.lastMonthSum.costSum)>Number(networkData.curMonthSum.costSum)?require('../../assets/img/down.png'):require('../../assets/img/up.png')" alt="">
                            </div>
                            <div style="font-size:24px;" v-else>NA</div>
                        </div>
                    </el-card>
                    <el-card class="h120" v-if="networkData && networkData.lastMonthSum && networkData.curMonthSum">
                        <div class="title">总用量</div>
                        <div class="cost">
                            <div class="left">
                                <p>{{ networkData.lastMonthSum.month }}</p>
                                <p class="num">{{ Number(networkData.lastMonthSum.usageSum).toFixed(4) }}</p>
                            </div>
                            <div class="left">
                                <p>{{ networkData.curMonthSum.month }}</p>
                                <p class="num">{{ networkData.curMonthSum.usageSum }}</p>
                            </div>
                        </div>
                        <div class="percent">
                            <div style="font-size:24px;" v-if="Number(networkData.lastMonthSum.usageSum) != Number(networkData.curMonthSum.usageSum)">
                                {{ percentage(networkData.lastMonthSum.usageSum,networkData.curMonthSum.usageSum) }}
                                <img :src="Number(networkData.lastMonthSum.usageSum)>Number(networkData.curMonthSum.usageSum)?require('../../assets/img/down.png'):require('../../assets/img/up.png')" alt="">
                            </div>
                            <div style="font-size:24px;" v-else>NA</div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="6">
                    <el-card>
                        <div class="title">费用明细</div>
                        <div id="chart1" class="chart"></div>
                    </el-card>
                </el-col>
                <el-col :span="6">
                    <el-card>
                        <div class="title">费用趋势</div>
                        <div id="chart2" class="chart"></div>
                    </el-card>
                </el-col>
                <el-col :span="6">
                    <el-card>
                        <div class="title">用量明细</div>
                        <div id="chart3" class="chart"></div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <el-row class="tableSelect">
            <div class="tools" style="display:flex;">
                <el-date-picker 
                    style="width:120px;"
                    @change="getDetails"
                    format="YYYY-MM"
                    value-format="YYYYMM"
                    v-model="value1"
                    type="month"
                    placeholder="选择月">
                </el-date-picker>
                <el-input placeholder="请输入ID搜索" style="width:120px;margin-left:10px;" v-model="keyValue" @input="filterDetails" @change="filterDetails"></el-input>
            </div>
            
            
            <el-table stripe :data="details" ref="tableref" height="calc(100vh - 554px)" style="width: 100%">
                <el-table-column label="ID" prop="linkId"></el-table-column>
                <el-table-column label="服务名称" prop="productCode"></el-table-column>
                <el-table-column label="月份" prop="month"></el-table-column>
                <el-table-column label="用量" prop="usage"></el-table-column>
                <el-table-column label="费用" prop="cost"></el-table-column>
            </el-table>
        </el-row>
    </div>
</template>

<script>
    import {getNetworkData,getNetworkDetails,getSalesList,getAgentList,getCustomerList,getPayerList} from '@/api/api'
    import * as echarts from 'echarts';

    export default{
        name:'networkSummary',
        data(){
            return{
                curRole:localStorage.getItem('curRole'),
                agentsList:[],
                payersList:[],
                customersList:[],
                salesList:[],
                formInline:{
                    month:0,
                    region:'cn',
                    sales:'',
                    agent_id:'',
                    payer_id:'',
                    company_id:''
                },
                regionList:[
                    {label:'全部',value:''},
                    {label:'中国',value:'cn'},
                    {label:'Global',value:'global'} 
                ],
                loading:false,
                networkData:null,
                value1:[],
                details:[],
                keyValue:'',
            }
        },
        created(){
            let date = new Date();
            //获取当前年份的后一年
            let endY =date.getFullYear();
            //获取上一个月
            let endM = (date.getMonth() < 10 ? '0' + (date.getMonth() ) : date.getMonth());
            this.formInline.month = endY+endM;
            this.value1= endY + endM;
            if(this.curRole=='agent'||this.curRole=='customer'){
                this.formInline.region='global'
            }
            this.getPermissionList();
        },
        methods:{
            beforeTime(n){
                let date = new Date();
                date.setMonth(date.getMonth() - n);
                date.toLocaleDateString();
                let y = date.getFullYear();
                let m = date.getMonth() + 1;
                m = m<10?'0'+m:m;
                return y.toString()+m;
            },
            async getPermissionList(){
                this.loading = true;
                if(this.curRole!='customer'){
                    await this.getPayersList();
                    await this.getAgentsList();
                }
                if(this.curRole=='admin'||this.curRole=='sales'){
                    await this.getSaleList();
                }
                await this.getCustomersList();
                await this.search()
                await this.getDetails();
                this.loading = false;
            },
            async getDetails(){
                await getNetworkDetails({monthFrom:this.value1,monthTo:this.value1}).then(res=>{
                    if(res.code==2000){
                        this.details = res.data;
                        localStorage.setItem('details',JSON.stringify(res.data));
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            }, 
            filterDetails(){
                var data = JSON.parse(localStorage.getItem('details'));
                if(this.keyValue&&this.keyValue!=''){
                    this.details = data.filter(item=>{
                        return item.linkId.indexOf(this.keyValue.trim())!=-1;
                    })
                }else{
                    this.details = data;
                }
            },
            //获取列表
            async search() {
                this.loading = true;
                this.networkData = null;
                try {
                await getNetworkData(this.formInline).then(res => {
                    if(res.code ==2000) {
                        this.networkData = res.data;
                        var costData = [],usageData=[];
                        this.networkData.sumByProductCode.forEach(el=>{
                            costData.push({
                                value:el.costSum,
                                name:el.productCode
                            })
                            usageData.push({
                                value:el.usageSum,
                                name:el.productCode
                            })
                        })
                        var xData=[],yData=[];
                        this.networkData.sumlist.forEach(el=>{
                            xData.push(el.month);
                            yData.push({
                                value:el.costSum,
                                itemStyle:{
                                    borderRadius:[10,10,0,0]
                                }
                            })
                        })
                        this.$nextTick(()=>{
                            this.loadPieChart(document.getElementById('chart1'),'费用明细',costData)
                            this.loadBarChart(document.getElementById('chart2'),xData,yData)
                            this.loadPieChart(document.getElementById('chart3'),'用量明细',usageData)
                        })
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
                } finally {
                    this.loading = false;
                }
            },
            // 获取伙伴列表
            async getAgentsList(){
                await getAgentList({company:'',payers:'',sales:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.agentsList=res.data.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            }, 
            // 获取销售列表
            async getSaleList(){
                await getSalesList({name:'',phone:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.salesList=res.data.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            // 获取客户列表
            async getCustomersList(){
                await getCustomerList({company:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.customersList=res.data.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            // 获取payer列表
            async getPayersList(){
                await getPayerList({name:'',payer_id:'',region:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.payersList=res.data.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            }, 
            // 价格变成k或者M
            priceTokOrToM(num){
                if (num >= 1000 && num < 1000000) {
                    return (num / 1000).toFixed(2) + 'k';
                } else if (num >= 1000000) {
                    return (num / 1000000).toFixed(2) + 'M';
                }
                return num.toString();
            },
            // 计算两个值的percent,num1为上月费用，num2为当月费用
            percentage(num1,num2){
                var numA = Number(num1).toFixed(2);
                var numB = Number(num2).toFixed(2);
                let upOrDown = '', percent = '';
                if (Number(numA) < Number(numB)) {
                    upOrDown = '+';
                    percent = Math.abs((((Number(numB) - Number(numA)) / Number(numA))*100).toFixed(2)) + '%';
                } else if (Number(numA) > Number(numB)) {
                    upOrDown = '-';
                    percent = Math.abs((((Number(numA) - Number(numB)) / Number(numA))*100).toFixed(2)) + '%';
                }
                return `${upOrDown}${percent}`
            },

            loadLineChart(dom,xData,yData){
                var myChart = echarts.getInstanceByDom(dom) || echarts.init(dom);
                var option;
                option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['Usage', 'RIFee', 'SP抵扣', '积分', 'Tax','Other']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: xData
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: 'Usage',
                            type: 'line',
                            stack: 'Total',
                            data: yData.usage
                        },
                        {
                            name: 'RIFee',
                            type: 'line',
                            stack: 'Total',
                            data: yData.rifee
                        },
                        {
                            name: 'SP抵扣',
                            type: 'line',
                            stack: 'Total',
                            data: yData.sp
                        },
                        {
                            name: '积分',
                            type: 'line',
                            stack: 'Total',
                            data: yData.credit
                        },
                        {
                            name: 'Tax',
                            type: 'line',
                            stack: 'Total',
                            data: yData.tax
                        },
                        {
                            name: 'Other',
                            type: 'line',
                            stack: 'Total',
                            data: yData.others
                        }
                    ]
                };
                option && myChart.setOption(option);
            },
            loadBarChart(dom,xData,yData){
                const chart = echarts.getInstanceByDom(dom) || echarts.init(dom);
                var option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                        type: 'shadow'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        data: xData
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name:'费用趋势',
                            data: yData,
                            barWidth: '60%',      
                            type: 'bar',
                        }
                    ]
                };
                option && chart.setOption(option);
            },

            loadPieChart(dom,name,data){
                var myChart = echarts.getInstanceByDom(dom) || echarts.init(dom);
                var option;
                option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    series: [
                        {
                            name: name,
                            type: 'pie',
                            radius: [20, 100],
                            center: ['50%', '50%'],
                            roseType: 'radius',
                            itemStyle: {
                                borderRadius: 5
                            },
                            // label: {
                            //     show: false
                            // },
                            emphasis: {
                                label: {
                                show: true
                                }
                            },
                            data: data
                        }
                    ]
                };
                option && myChart.setOption(option);
            },

            loadHbarChart(dom,data,dir){
                var myChart = echarts.init(dom);
                var option;
                const grid = {
                    left: 30,
                    right: 20,
                    top: 20,
                    bottom: 20
                };
                let yAxis = null,xAxis = null;
                if(dir=='H'){
                    yAxis={
                        type: 'category',
                        data: ['C5A', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                    }
                    xAxis={
                        type: 'value'
                    }
                }else{
                    xAxis={
                        type: 'category',
                        data: ['C5A', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                    }
                    yAxis={
                        type: 'value'
                    }
                }
                option = {
                    grid,
                    yAxis,
                    xAxis,
                    series: [
                        {
                        data: data,
                        type: 'bar',
                        // orientation: 'horizontal'
                        }
                    ]
                };

                option && myChart.setOption(option);
            },

            loadWordCloud(dom,data){
                var myChart = echarts.init(dom);
                var option;
                option = {
                    series: [{
                        type: 'wordCloud',
                        /**
                         * 绘制词云的形状, 值为回调函数 或 关键字, 默认 circle
                         *  关键字:
                         * 
                         * circle（圆形）  词的数量不太多的时候，效果不明显，它会趋向于画一个椭圆
                         * cardioid（苹果形或心形曲线）
                         * diamond（菱形 正方形）
                         * triangle-forward（三角形-向前）
                         * triangle（三角形-直立）
                         * pentagon（五边形）
                         * star（星形）
                         */
                        shape: 'circle',
                        // 保持 maskImage 的纵横比或形状的纵横比为 1：1
                        keepAspect: false,
                        /**
                         * 词云轮廓图，支持为 HTMLImageElement, HTMLCanvasElement，不支持路径字符串, 不包含白色区域; 可选选项
                         * shape选项将随着云的形状增长而继续应用
                         * 有形状限制的时候，最好用背景图来实现，而且这个背景图一定要放base64的，不然词云画不出来
                         */
                        // maskImage: maskImage,
                    
                        // 词云整个图表放置的位置 和 尺寸大小
                        left: 'center',
                        top: 'center',
                        width: '100%',
                        height: '100%',
                        right: null,
                        bottom: null,
                        // 词云文本大小范围,  默认为最小12像素，最大60像素
                        sizeRange: [12, 60],
                        // 词云文字旋转范围和步长。 文本将通过旋转在[-90，90]范围内随机旋转步骤45
                        // 如果都设置为 0 , 则是水平显示
                        rotationRange: [-90, 90],
                        rotationStep: 45,
                        /**
                         * 词间距, 距离越大，单词之间的间距越大, 单位像素
                         * 这里间距太小的话，会出现大词把小词套住的情况，比如一个大的口字，中间会有比较大的空隙，这时候他会把一些很小的字放在口字里面，这样的话，鼠标就无法选中里面的那个小字
                         */
                        gridSize: 8,
                        // 设置为true可以使单词部分在画布之外绘制, 允许绘制大于画布大小的单词
                        drawOutOfBound: false,
                        /**
                         * 布局的时候是否有动画
                         * 注意：禁用时，当单词较多时，将导致UI阻塞。
                         */
                        layoutAnimation: true,
                        // 这是全局的文字样式，相对应的还可以对每个词设置字体样式
                        textStyle: {
                            fontFamily: 'sans-serif',
                            fontWeight: 'bold',
                            // 颜色可以用一个函数来返回字符串
                            color: function () {
                            // 随机颜色
                            return (
                                'rgb(' +
                                [
                                Math.round(Math.random() * 160),
                                Math.round(Math.random() * 160),
                                Math.round(Math.random() * 160),
                                ].join(',') +
                                ')'
                            )
                            },
                        },
                        // 鼠标hover的特效样式
                        emphasis: {
                            focus: 'self',
                            textStyle: {
                                textShadowBlur: 10,
                                textShadowColor: '#999'
                            }
                        },
                    
                        /**
                         * 词云数据，必须是一个数组，每个数组项必须有name和value属性
                         * 设置单个文本的样式：  textStyle 
                         * 
                         * 例：{
                                        name: '',
                                        value: 40,
                                        textStyle: {
                                        }
                                    },
                        */
                        data: data
                    }]
                };
                
                // // 使用刚指定的配置项和数据显示图表。
                option && myChart.setOption(option);

                // const defaultSeries = [{
                    
                // }]
                // let seriesData = props.options.series;
                // const series = merge({}, defaultSeries[0], seriesData[0]) // {}表示合并后的新对象，可以传入一个空对象作为初始值
            },
            
            getRandomColor(){
                var letters = '0123456789ABCDEF';
                var color = '#';
                for (var i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)];
                }
                return color;
            },
            randomArr(max,min,num){
                var arr=[]
                for(var i=0;i<num;i++){
                    arr.push({
                        value:Math.floor(Math.random() * (max - min + 1)) + min,
                        itemStyle:{
                            color:this.getRandomColor()
                        }  
                    })
                }
                return arr;
            },
            monthToEnMonth(myDate){
                let date = new Date(myDate.replace(/-/g,'/'));
                let chinaDate = date.toDateString();
                let chinaDateArray = chinaDate.split(' ');
                return `${chinaDateArray[1]} ${chinaDateArray[3]}`;
            },
             
        },
        mounted(){
            
            // this.loadBarChart(document.getElementById('mychart1'),[
            //     [100, 302, -301, 334, 390, 330, 320],
            //     [-320, 132, 101, 134, 90, 230, 210],
            //     [220, 182, -191, 234, 290, 330, 310],
            //     [150, 212, 201, 154, -190, 330, 410],
            //     [820, 832, -901, 934, 1290, 1330, 1320]
            // ])
            // this.loadPieChart(document.getElementById('mychart2'),[
            //     { value: 1048, name: 'Search Engine' },
            //     { value: 735, name: 'Direct' },
            //     { value: 580, name: 'Email' },
            //     { value: 484, name: 'Union Ads' },
            //     { value: 300, name: 'Video Ads' }
            // ])
            // this.loadPieChart(document.getElementById('mychart3'),[
            //     { value: 1048, name: 'Search Engine' },
            //     { value: 735, name: 'Direct' },
            //     { value: 580, name: 'Email' },
            //     { value: 484, name: 'Union Ads' },
            //     { value: 300, name: 'Video Ads' }
            // ])
            // this.loadPieChart(document.getElementById('mychart4'),[
            //     { value: 1048, name: 'Search Engine' },
            //     { value: 735, name: 'Direct' },
            //     { value: 580, name: 'Email' },
            //     { value: 484, name: 'Union Ads' },
            //     { value: 300, name: 'Video Ads' }
            // ])
            // this.loadHbarChart(document.getElementById('mychart5'),this.randomArr(200,100,7),'H')
            
            // this.loadHbarChart(document.getElementById('mychart6'),this.randomArr(200,100,7),'V')
            // this.loadHbarChart(document.getElementById('mychart7'),this.randomArr(200,100,7),'H')
        }
    }
</script>
<style lang="scss" scoped>
    .network{
        min-height:calc(100vh - 120px);
        .el-card{
            overflow: visible;
        }
        .el-card.h120{
            height:156px;
            :deep(.el-card__body){
                position: relative;
                .cost{
                    display: flex;
                    justify-content: space-between;
                    .left{
                        p{
                            font-size:16px;
                            margin-top:20px;
                            font-weight:bold;
                        }
                        p.num{
                            font-size:16px;
                            margin-top:12px;
                            font-weight:normal;
                        }
                        p.num.last{
                            color:#ccc;
                            font-weight:normal;
                            text-decoration:line-through;
                        }
                    }
                }
                .percent{
                    position: absolute;
                    left:50%;
                    bottom:20px;
                    transform: translate(-50%,0);
                    font-size:24px;
                    img{
                        width: 10px;
                    }
                }
            }
        }
        .title{
            font-size:24px;
            border-left:4px solid #409eff;
            margin-bottom: 20px;
            padding-left:8px;
        }
        .chart{
            width:100%;
            height:230px;    
        }
    }
</style>